export enum ActionTypes {
  SET_COUPON_NAME = 'SET_COUPON_NAME',
  SET_COUPON_STATUS = 'SET_COUPON_STATUS',
  SET_TYPE_OF_COUPON = 'SET_TYPE_OF_COUPON',
  SET_COUPON_VALUE = 'SET_COUPON_VALUE',
  SET_MINIMUM_PURCHASE = 'SET_MINIMUM_PURCHASE',
  SET_MAXIMUM_DISCOUNT = 'SET_MAXIMUM_DISCOUNT',
  SET_VALIDATE_DATE = 'SET_VALIDATE_DATE',
  SET_USAGE_LIMIT = 'SET_USAGE_LIMIT',
  SET_USAGE_LIMIT_BY_USER = 'SET_USAGE_LIMIT_BY_USER',
  SET_USERS_RESTRICTION = 'SET_USERS_RESTRICTION',
  SET_COUPON_TO_EDIT = 'SET_COUPON_TO_EDIT',
  SET_USAGE_LIMIT_TYPE = 'SET_USAGE_LIMIT_TYPE',
  SET_USAGE_LIMIT_BY_USER_TYPE = 'SET_USAGE_LIMIT_BY_USER_TYPE',
}
